

// import { useState, useEffect } from "react";
// import {
//   TableContainer,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Paper,
//   Card,
//   CardContent,
//   Box,
//   Typography,
//   Button,
//   Alert,
//   Snackbar,
// } from "@mui/material";

// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";
// import TextField from "@mui/material/TextField";
// import { useStateContext } from "../context/ContextProvider";

// import axiosClient from "../axiosClient";
// import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
// import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
// import UserEditModal from "../components/UserEditModal";
// import ClientComment from "../components/ClientComment";

// import { AddComment } from "@mui/icons-material";
// import { useTheme } from "@mui/material/styles";
// import { useTranslation } from "react-i18next";   // <-- enable translations

// const genderChoices = [
//   { label: "Male", value: "M" },
//   { label: "Female", value: "F" },
// ];

// const roleChoices = [
//   { label: "Admin", value: "ADMIN" },
//   { label: "Client", value: "CLIENT" },
//   { label: "Staff", value: "STAFF" },
// ];

// const EditDeleteUsers = () => {
//   const theme = useTheme();
//   const { t } = useTranslation();                // <-- hook
//   const [users, setUsers] = useState([]);
//   const [openModal, setOpenModal] = useState(false);
//   const [openClientModal, setOpenClientModal] = useState(false);
//   const { user } = useStateContext();
//   const [id, setId] = useState();

//   const [gender, setGender] = useState("");
//   const [role, setRole] = useState("");
//   const [search, setSearch] = useState("");

//   const handleModalOpen = (id) => {
//     setId(id);
//     setOpenModal(true);
//   };

//   const handleModalClose = () => {
//     setOpenModal(false);
//   };

//   const handleClientModalOpen = (id) => {
//     setId(id);
//     setOpenClientModal(true);
//   };

//   const handleClientModalClose = () => {
//     setOpenClientModal(false);
//   };

//   const getUsers = () => {
//     const params = {};

//     if (role) params["role"] = role;
//     if (gender) params["gender"] = gender;
//     if (search) params["search"] = search;

//     axiosClient
//       .get("api/print_all_users/", { params })
//       .then((data) => {
//         setUsers(data.data.custom_users);
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   };

//   const handleDelete = (userId) => {
//     axiosClient
//       .delete(`api/user/${userId}/`)
//       .then(() => {
//         getUsers();
//       })
//       .catch((error) => {
//         console.error("Error deleting user:", error);
//       });
//   };

//   useEffect(() => {
//     getUsers();
//     // eslint-disable-next-line
//   }, [gender, role, search]);

//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "",
//   });

//   const handleSend = async (email) => {
//     try {
//       const response = await axiosClient.post("/auth/forgot_password/", {
//         email,
//       });
//       console.log(response.data);
//       setSnackbar({
//         open: true,
//         message: t("Password reset email sent successfully!"),
//         severity: "success",
//       });
//     } catch (error) {
//       console.error("Error sending email:", error.response?.data);
//       setSnackbar({
//         open: true,
//         message: t("Failed to send password reset email."),
//         severity: "error",
//       });
//     }
//   };

//   const handleClose = () => {
//     setSnackbar({ open: false, message: "", severity: "" });
//   };

//   return (
//     <>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={4000}
//         onClose={handleClose}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//       >
//         <Alert onClose={handleClose} severity={snackbar.severity} sx={{ width: "100%" }}>
//           {snackbar.message}
//         </Alert>
//       </Snackbar>

//       <Box
//         display="flex"
//         justifyContent="center"
//         alignItems="center"
//         marginTop="16"
//       >
//         <Card elevation={16}>
//           <CardContent>
//             {/* Search & Filter block */}
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 mb: 5,
//                 gap: 2,
//                 width: "100%",
//               }}
//             >
//               <Box sx={{ width: "100%" }}>
//                 <Typography
//                   variant="body1"
//                   sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}
//                 >
//                   {t("Search By")}
//                 </Typography>
//                 <TextField
//                   fullWidth
//                   id="search"
//                   label={t("Search")}
//                   variant="outlined"
//                   value={search}
//                   onChange={(e) => setSearch(e.target.value)}
//                 />
//               </Box>

//               <Box sx={{ width: "100%" }}>
//                 <Typography
//                   variant="body1"
//                   sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}
//                 >
//                   {t("Filter By")}
//                 </Typography>
//                 <Box sx={{ display: "flex", gap: 2 }}>
//                   {/* Role filter */}
//                   <FormControl fullWidth>
//                     <InputLabel id="role-select-label">{t("Role")}</InputLabel>
//                     <Select
//                       labelId="role-select-label"
//                       id="role-select"
//                       value={role}
//                       label={t("Role")}
//                       onChange={(e) => setRole(e.target.value)}
//                       sx={{ textAlign: "left" }}
//                     >
//                       <MenuItem value="">{t("Default")}</MenuItem>
//                       {roleChoices.map((roleChoice, idx) => (
//                         <MenuItem key={idx} value={roleChoice.value}>
//                           {roleChoice.value === "ADMIN"
//                             ? t("Secretary")
//                             : roleChoice.value === "STAFF"
//                             ? t("Doctor")
//                             : t("Patient")}
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>

//                   {/* Gender filter */}
//                   <FormControl fullWidth>
//                     <InputLabel id="gender-select-label">
//                       {t("Gender")}
//                     </InputLabel>
//                     <Select
//                       labelId="gender-select-label"
//                       id="gender-select"
//                       value={gender}
//                       label={t("Gender")}
//                       onChange={(e) => setGender(e.target.value)}
//                       sx={{ textAlign: "left" }}
//                     >
//                       <MenuItem value="">{t("Default")}</MenuItem>
//                       {genderChoices.map((genderChoice, idx) => (
//                         <MenuItem key={idx} value={genderChoice.value}>
//                           {t(genderChoice.label)}
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>
//                 </Box>
//               </Box>
//             </Box>

//             {/* Table */}
//             <TableContainer component={Paper} style={{ maxHeight: 800 }}>
//               <Table>
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>
//                       <Typography
//                         variant="h7"
//                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
//                       >
//                         {t("Name")}
//                       </Typography>
//                     </TableCell>
//                     <TableCell>
//                       <Typography
//                         variant="h7"
//                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
//                       >
//                         {t("Surname")}
//                       </Typography>
//                     </TableCell>
//                     <TableCell>
//                       <Typography
//                         variant="h7"
//                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
//                       >
//                         {t("Date of Birth")}
//                       </Typography>
//                     </TableCell>
//                     <TableCell>
//                       <Typography
//                         variant="h7"
//                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
//                       >
//                         {t("Gender")}
//                       </Typography>
//                     </TableCell>
//                     <TableCell>
//                       <Typography
//                         variant="h7"
//                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
//                       >
//                         {t("Email")}
//                       </Typography>
//                     </TableCell>
//                     <TableCell>
//                       <Typography
//                         variant="h7"
//                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
//                       >
//                         {t("Hardcopy Consent")}
//                       </Typography>
//                     </TableCell>
//                     <TableCell>
//                       <Typography
//                         variant="h7"
//                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
//                       >
//                         {t("Username")}
//                       </Typography>
//                     </TableCell>
//                     <TableCell>
//                       <Typography
//                         variant="h7"
//                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
//                       >
//                         {t("Phone Number")}
//                       </Typography>
//                     </TableCell>
//                     <TableCell>
//                       <Typography
//                         variant="h7"
//                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
//                       >
//                         {t("Role")}
//                       </Typography>
//                     </TableCell>
//                     <TableCell>
//                       <Typography
//                         variant="h7"
//                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
//                       >
//                         {t("Assigned Doctor")}
//                       </Typography>
//                     </TableCell>
//                     <TableCell>
//                       <Typography
//                         variant="h7"
//                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
//                       >
//                         {t("User ID")}
//                       </Typography>
//                     </TableCell>
//                     <TableCell sx={{ textAlign: "center" }}>
//                       <Typography variant="h7" sx={{ fontWeight: "bold" }}>
//                         {t("Action")}
//                       </Typography>
//                     </TableCell>
//                     <TableCell>
//                       <Typography
//                         variant="h7"
//                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
//                       >
//                         {t("Forgot Password")}
//                       </Typography>
//                     </TableCell>
//                     <TableCell>
//                       <Typography
//                         variant="h7"
//                         sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
//                       >
//                         {t("Comment")}
//                       </Typography>
//                     </TableCell>
//                   </TableRow>
//                 </TableHead>

//                 <TableBody>
//                   {users.map((row, index) => (
//                     <TableRow key={index}>
//                       <TableCell>{row.first_name}</TableCell>
//                       <TableCell>{row.last_name}</TableCell>
//                       <TableCell>{row.date_birth}</TableCell>
//                       <TableCell sx={{ whiteSpace: "nowrap" }}>
//                         {row.gender === "M"
//                           ? t("Male")
//                           : row.gender === "F"
//                           ? t("Female")
//                           : t("Non-declared")}
//                       </TableCell>
//                       <TableCell>{row.email}</TableCell>
//                       <TableCell>
//                         {row.hardcopy_consent ? t("Yes") : t("No")}
//                       </TableCell>
//                       <TableCell>{row.username}</TableCell>
//                       <TableCell>{row.phone_number}</TableCell>
//                       <TableCell>
//                         {row.user_role === "ADMIN"
//                           ? t("Secretary")
//                           : row.user_role === "STAFF"
//                           ? t("Doctor")
//                           : row.user_role === "CLIENT"
//                           ? t("Patient")
//                           : t("Non-declared")}
//                       </TableCell>
//                       <TableCell>{row?.assigned_staff?.name}</TableCell>
//                       <TableCell>{row.id}</TableCell>

//                       <TableCell sx={{ textAlign: "center" }}>
//                         <Box
//                           sx={{ display: "flex", alignItems: "center", gap: 1 }}
//                         >
//                           <BorderColorOutlinedIcon
//                             onClick={() => handleModalOpen(row?.id)}
//                             sx={{
//                               cursor: "pointer",
//                               color:
//                                 theme.palette.mode === "dark" ? "orange" : "blue",
//                             }}
//                           />
//                           <Box>.</Box>
//                           <DeleteOutlineOutlinedIcon
//                             onClick={() => handleDelete(row?.id)}
//                             sx={{ cursor: "pointer", color: "red" }}
//                           />
//                         </Box>
//                       </TableCell>

//                       <TableCell>
//                         <Button
//                           disabled={
//                             user.user_role === "STAFF" &&
//                             !(
//                               row.user_role === "ADMIN" ||
//                               row.assigned_staff?.id === user.id
//                             )
//                           }
//                           variant="contained"
//                           onClick={() => handleSend(row.email)}
//                         >
//                           {t("Send")}
//                         </Button>
//                       </TableCell>

//                       <TableCell>
//                         <Box>
//                           <AddComment
//                             sx={{
//                               cursor: "pointer",
//                               color:
//                                 theme.palette.mode === "dark" ? "orange" : "blue",
//                             }}
//                             onClick={() => handleClientModalOpen(row.id)}
//                           />
//                         </Box>
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </CardContent>
//         </Card>
//       </Box>

//       <UserEditModal
//         open={openModal}
//         handleClose={handleModalClose}
//         id={id}
//         getUsers={getUsers}
//       />

//       <ClientComment
//         open={openClientModal}
//         handleClose={handleClientModalClose}
//         id={id}
//         getUsers={getUsers}
//       />
//     </>
//   );
// };

// export default EditDeleteUsers;

import { useState, useEffect } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Card,
  CardContent,
  Box,
  Typography,
  Button,
  Alert,
  Snackbar,
} from "@mui/material";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { useStateContext } from "../context/ContextProvider";

import axiosClient from "../axiosClient";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import UserEditModal from "../components/UserEditModal";
import ClientComment from "../components/ClientComment";

import { AddComment } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

const genderChoices = [
  { label: "Male", value: "M" },
  { label: "Female", value: "F" },
];

const roleChoices = [
  { label: "Admin", value: "ADMIN" },
  { label: "Client", value: "CLIENT" },
  { label: "Staff", value: "STAFF" },
];

const EditDeleteUsers = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [users, setUsers] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openClientModal, setOpenClientModal] = useState(false);
  const { user } = useStateContext();
  const [id, setId] = useState();

  const [gender, setGender] = useState("");
  const [role, setRole] = useState("");
  const [search, setSearch] = useState("");

  const handleModalOpen = (id) => {
    setId(id);
    setOpenModal(true);
  };

  const handleModalClose = () => {
    setOpenModal(false);
  };

  const handleClientModalOpen = (id) => {
    setId(id);
    setOpenClientModal(true);
  };

  const handleClientModalClose = () => {
    setOpenClientModal(false);
  };

  const getUsers = () => {
    const params = {};

    if (role) params["role"] = role;
    if (gender) params["gender"] = gender;
    if (search) params["search"] = search;

    axiosClient
      .get("api/print_all_users/", { params })
      .then((data) => {
        setUsers(data.data.custom_users);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDelete = (userId) => {
    axiosClient
      .delete(`api/user/${userId}/`)
      .then(() => {
        getUsers();
      })
      .catch((error) => {
        console.error("Error deleting user:", error);
      });
  };

  useEffect(() => {
    getUsers();
    // eslint-disable-next-line
  }, [gender, role, search]);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const handleSend = async (email) => {
    try {
      const response = await axiosClient.post("/auth/forgot_password/", {
        email,
      });
      console.log(response.data);
      setSnackbar({
        open: true,
        message: t("Password reset email sent successfully!"),
        severity: "success",
      });
    } catch (error) {
      console.error("Error sending email:", error.response?.data);
      setSnackbar({
        open: true,
        message: t("Failed to send password reset email."),
        severity: "error",
      });
    }
  };

  const handleClose = () => {
    setSnackbar({ open: false, message: "", severity: "" });
  };

  return (
    <>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleClose} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        marginTop="16"
      >
        <Card elevation={16}>
          <CardContent>
            {/* Search & Filter block */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mb: 5,
                gap: 2,
                width: "100%",
              }}
            >
              {/* Search */}
              <Box sx={{ width: "100%" }}>
                <Typography
                  variant="body1"
                  sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}
                >
                  {t("Search By")}
                </Typography>
                <TextField
                  fullWidth
                  id="search"
                  label={t("Search")}
                  variant="outlined"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </Box>

              {/* Filters */}
              <Box sx={{ width: "100%" }}>
                <Typography
                  variant="body1"
                  sx={{ textAlign: "left", mb: 1, fontWeight: "bold" }}
                >
                  {t("Filter By")}
                </Typography>
                <Box sx={{ display: "flex", gap: 2 }}>
                  {/* Role filter */}
                  <FormControl fullWidth>
                    <InputLabel id="role-select-label">{t("Role")}</InputLabel>
                    <Select
                      labelId="role-select-label"
                      id="role-select"
                      value={role}
                      label={t("Role")}
                      onChange={(e) => setRole(e.target.value)}
                      sx={{ textAlign: "left" }}
                    >
                      <MenuItem value="">{t("Default")}</MenuItem>
                      {roleChoices.map((roleChoice, idx) => (
                        <MenuItem key={idx} value={roleChoice.value}>
                          {roleChoice.value === "ADMIN"
                            ? t("Secretary")
                            : roleChoice.value === "STAFF"
                            ? t("Doctor")
                            : t("Patient")}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {/* Gender filter */}
                  <FormControl fullWidth>
                    <InputLabel id="gender-select-label">
                      {t("Gender")}
                    </InputLabel>
                    <Select
                      labelId="gender-select-label"
                      id="gender-select"
                      value={gender}
                      label={t("Gender")}
                      onChange={(e) => setGender(e.target.value)}
                      sx={{ textAlign: "left" }}
                    >
                      <MenuItem value="">{t("Default")}</MenuItem>
                      {genderChoices.map((genderChoice, idx) => (
                        <MenuItem key={idx} value={genderChoice.value}>
                          {t(genderChoice.label)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Box>
            </Box>

            {/* Table */}
            <TableContainer component={Paper} style={{ maxHeight: 800 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <Typography
                        variant="h7"
                        sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
                      >
                        {t("Name")}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="h7"
                        sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
                      >
                        {t("Surname")}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="h7"
                        sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
                      >
                        {t("Date of Birth")}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="h7"
                        sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
                      >
                        {t("Gender")}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="h7"
                        sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
                      >
                        {t("Email")}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="h7"
                        sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
                      >
                        {t("Hardcopy Consent")}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="h7"
                        sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
                      >
                        {t("Username")}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="h7"
                        sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
                      >
                        {t("Phone Number")}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="h7"
                        sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
                      >
                        {t("Role")}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="h7"
                        sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
                      >
                        {t("Assigned Doctor")}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="h7"
                        sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
                      >
                        {t("User ID")}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      <Typography variant="h7" sx={{ fontWeight: "bold" }}>
                        {t("Action")}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="h7"
                        sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
                      >
                        {t("Forgot Password")}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="h7"
                        sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
                      >
                        {t("Comment")}
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {users.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row.first_name}</TableCell>
                      <TableCell>{row.last_name}</TableCell>
                      <TableCell>{row.date_birth}</TableCell>
                      <TableCell sx={{ whiteSpace: "nowrap" }}>
                        {row.gender === "M"
                          ? t("Male")
                          : row.gender === "F"
                          ? t("Female")
                          : t("Non-declared")}
                      </TableCell>
                      <TableCell>{row.email}</TableCell>
                      <TableCell>
                        {row.hardcopy_consent ? t("Yes") : t("No")}
                      </TableCell>
                      <TableCell>{row.username}</TableCell>
                      <TableCell>{row.phone_number}</TableCell>
                      <TableCell>
                        {row.user_role === "ADMIN"
                          ? t("Secretary")
                          : row.user_role === "STAFF"
                          ? t("Doctor")
                          : row.user_role === "CLIENT"
                          ? t("Patient")
                          : t("Non-declared")}
                      </TableCell>
                      <TableCell>{row?.assigned_staff?.name}</TableCell>
                      <TableCell>{row.id}</TableCell>

                      <TableCell sx={{ textAlign: "center" }}>
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <BorderColorOutlinedIcon
                            onClick={() => handleModalOpen(row?.id)}
                            sx={{
                              cursor: "pointer",
                              color:
                                theme.palette.mode === "dark"
                                  ? "orange"
                                  : "blue",
                            }}
                          />
                          <Box>.</Box>
                          <DeleteOutlineOutlinedIcon
                            onClick={() => handleDelete(row?.id)}
                            sx={{ cursor: "pointer", color: "red" }}
                          />
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Button
                          disabled={
                            user.user_role === "STAFF" &&
                            !(
                              row.user_role === "ADMIN" ||
                              row.assigned_staff?.id === user.id
                            )
                          }
                          variant="contained"
                          onClick={() => handleSend(row.email)}
                        >
                          {t("Send")}
                        </Button>
                      </TableCell>

                      <TableCell>
                        <Box>
                          <AddComment
                            sx={{
                              cursor: "pointer",
                              color:
                                theme.palette.mode === "dark"
                                  ? "orange"
                                  : "blue",
                            }}
                            onClick={() => handleClientModalOpen(row.id)}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Box>

      <UserEditModal
        open={openModal}
        handleClose={handleModalClose}
        id={id}
        getUsers={getUsers}
      />

      <ClientComment
        open={openClientModal}
        handleClose={handleClientModalClose}
        id={id}
        getUsers={getUsers}
      />
    </>
  );
};

export default EditDeleteUsers;
